export const defaultStarSvg = `
<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 28 26">
  <defs>
    <path id="path-1" d="M62 0l4 10h10l-9 6 4 10-9-6-9 6 4-10-9-6h11l3-10z"/>
  </defs>
  <g id="002_Travel_Hotels_Step1(Search)_Desktop" fill-rule="nonzero" transform="translate(-615 -351)">
    <g id="Form" transform="translate(0 125)">
      <g id="G_4_PrefrencesTravel_Hotel" transform="translate(51 160)">
        <g id="Hotel" transform="translate(516 39)">
          <g id="Stars" transform="translate(0 27)">
            <path id="Shape" d="M62 2l-3 8h-9l7 6-3 9 8-6 8 6-3-9 8-6H65l-3-8z"/>
          </g>
        </g>
      </g>
    </g>
  </g>
  <linearGradient id="halfGradient">
    <stop offset="50%" stop-color="#896806"/>
    <stop offset="50%" stop-opacity="0"/>
  </linearGradient>
  <linearGradient id="halfGradientBlack">
    <stop offset="50%" stop-color="#000000"/>
    <stop offset="50%" stop-opacity="0"/>
  </linearGradient>
  <linearGradient id="reverseHalfGradientBlack">
    <stop offset="50%" stop-opacity="0"/>
    <stop offset="50%" stop-color="#000000"/>
  </linearGradient>
  <linearGradient id="halfDarkTheme">
    <stop offset="50%" stop-color="#ffffff"/>
    <stop offset="50%" stop-opacity="0"/>
  </linearGradient>
</svg>
`;
